export const SET_ORDER_ACTIONS = "SET_ORDER_ACTIONS";
export const SET_ORDER_NUMBER = "SET_ORDER_NUMBER";
export const SET_ORDER_DETAILS = "SET_ORDER_DETAILS";
export const SET_SELECTED_ACTION = "SET_SELECTED_ACTION";
export const SET_PROCESSING_ORDER = "SET_PROCESSING_ORDER";
export const SET_COLUMN_VISIBILITY = "SET_COLUMN_VISIBILITY";
export const SET_SELECTED_SERVICE = "SET_SELECTED_SERVICE";
export const SET_SELECTED_ARTICLE = "SET_SELECTED_ARTICLE";
export const SET_SEARCH_COUNTRY = "SET_SEARCH_COUNTRY";
export const SET_PRIVILEGE_COUNTRIES = "SET_PRIVILEGE_COUNTRIES";
export const CLEAR_ORDER_DETAILS = "CLEAR_ORDER_DETAILS";
